export default __webpack_public_path__ + "static/media/shape1.e8676660.svg";